export default "__VITE_ASSET__BcWISKe0__"